import { render, staticRenderFns } from "./profileEdit-Panel.vue?vue&type=template&id=12dcff0f&lang=pug&"
import script from "./profileEdit-Panel.vue?vue&type=script&lang=js&"
export * from "./profileEdit-Panel.vue?vue&type=script&lang=js&"
import style0 from "./profileEdit-Panel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports